import { type FC } from 'react';
import { StringSmall } from '@components/Typography/Typography';
import { Scale } from '@components/ui/Scale/Scale';
import { useAppSelector } from '@redux/store';
import cn from 'classnames';

import { LightningIconAnimation } from '../Animations/LightningIconAnimation/LightningIconAnimation';

import css from './styles.module.scss';

interface EnergyProps {
  value?: number;
}

const Energy: FC<EnergyProps> = ({ value = 0 }) => {
  const energy = useAppSelector((state) => state.user.extendedInfo?.energy);
  const enertyLimit = useAppSelector(
    (state) => state.user.user?.settings.energyLimit,
  );

  const totalEnergy =
    (energy || 0) + value > (enertyLimit || 1000)
      ? 1000
      : (energy || 0) + value;

  return (
    <div className={css.energy}>
      <div className="relative w-6 h-6">
        <LightningIconAnimation
          energy={energy}
          className={cn(
            'absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 shrink-0 max-w-12',
            totalEnergy < 100 ? 'text-[#FF5858]' : 'text-[#FFC90A]',
          )}
        />
      </div>
      <div className="w-20 flex flex-col gap-1">
        <StringSmall weight="bold" className="flex items-center">
          <span>{totalEnergy}</span>
          <span className="text-white/40">/</span>
          <span className="text-white/40">{enertyLimit}</span>
        </StringSmall>
        <Scale
          className={cn(
            css.energyScale,
            totalEnergy < 100
              ? css['energyScale--low']
              : css['energyScale--default'],
          )}
          percentage={(totalEnergy * 100) / (enertyLimit || 1000)}
          height={6}
        />
      </div>
    </div>
  );
};

export { Energy };
